import {
  faEnvelope,
  faFolderOpen,
  faReceipt,
  faXmarkCircle
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Button, Nav, Offcanvas, Tab } from "react-bootstrap";

import { AppAuthRoles } from "../../config/app-constants";
import { IActiveMDTTabs } from "../../config/interfaces";
import { useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";
import { loggedInUserSelector } from "../../redux/slice/LoggedInUserSlice";
import FASvgIcon from "../FASvgIcon";
import DocumentsTab from "../tabs/assisted/DocumentsTab";
import MessagesTab from "../tabs/assisted/MessagesTab";
import TransactionInfoTab from "../tabs/assisted/TransactionInfoTab";

let INTERVAL: any;
type Props = {
  showCanvas: boolean;
  activeTab: IActiveMDTTabs;
  handleCloseBtnPress: () => void;
};

const ITRSingleFilingMDT: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, activeTab } = props;
  const { loggedInUser } = useAppSelector(loggedInUserSelector);

  const { currentFilingPlan, currentFilingData, currentFilingExpertData } =
    useAppSelector(ITRFilingSelector);

  const [activeMDT, setActiveMDT] = useState<IActiveMDTTabs>("messages");

  useEffect(() => {
    if (activeTab) {
      setActiveMDT(activeTab);
    } else {
      setActiveMDT("messages");
    }
  }, [activeTab]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Offcanvas.Body className="has-tabs">
          <Button
            variant="greyDefault"
            className="icon-only hide-offcanvas"
            onClick={() => {
              clearInterval(INTERVAL);
              handleCloseBtnPress();
            }}
          >
            <FASvgIcon icon={faXmarkCircle} />
          </Button>
          <Tab.Container activeKey={activeMDT}>
            <Nav variant="tabs" className="border-nav-tabs mb-0">
              {currentFilingExpertData &&
                currentFilingPlan &&
                !currentFilingPlan?.inactive &&
                currentFilingPlan?.planData?.type === "assisted" && (
                  <>
                    <Nav.Item onClick={() => setActiveMDT("messages")}>
                      <Nav.Link eventKey="messages">
                        <FASvgIcon icon={faEnvelope} /> Messages
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => setActiveMDT("documents")}>
                      <Nav.Link eventKey="documents">
                        <FASvgIcon icon={faFolderOpen} /> Documents
                      </Nav.Link>
                    </Nav.Item>
                  </>
                )}
              {loggedInUser?.uuid === currentFilingData?.userUuid ||
              loggedInUser?.role === AppAuthRoles.ADMIN ? (
                <Nav.Item onClick={() => setActiveMDT("transaction")}>
                  <Nav.Link eventKey="transaction">
                    <FASvgIcon icon={faReceipt} /> Transaction Info
                  </Nav.Link>
                </Nav.Item>
              ) : null}
            </Nav>

            <Tab.Content>
              {currentFilingExpertData &&
                currentFilingPlan &&
                !currentFilingPlan?.inactive &&
                currentFilingPlan?.planData?.type === "assisted" && (
                  <>
                    <Tab.Pane eventKey="messages" className="chat-window">
                      <MessagesTab activeMDT={activeMDT} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="documents">
                      <DocumentsTab activeMDT={activeMDT} />
                    </Tab.Pane>
                  </>
                )}
              <Tab.Pane eventKey="transaction">
                <TransactionInfoTab activeMDT={activeMDT} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ITRSingleFilingMDT;
